import { useTranslation } from 'react-i18next';

import { useModal } from 'Store/modal';
import useDeleteTarget from 'Domain/target/useDeleteTarget';

const useOpenDeleteModal = () => {
  const { onOpenModal } = useModal();
  const { t } = useTranslation('target');

  const { mutate: onDelete } = useDeleteTarget({ t });

  const onOpenDeleteModal = (id) => {
    onOpenModal({
      width: '420px',
      maxWidth: '420px',
      isOpen: true,
      type: 'cancel',
      title: t('deleteModal.title'),
      contentDescription: t('deleteModal.description'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('deleteModal.submitButton'),
      secondaryButtonText: t('deleteModal.cancelButton'),
      onClickPrimaryButton: () => onDelete(id),
    });
  };

  return { onOpenDeleteModal };
};

export default useOpenDeleteModal;
